import { ModeT } from "model/UserModel"
import { IconType } from "react-icons"
import {
  FiBookOpen,
  FiBox,
  FiClock,
  FiDatabase,
  FiFileText,
  FiMessageCircle,
  FiPlayCircle,
  FiTool,
} from "react-icons/fi"

export type Route = {
  title: string
  url?: string
  mode?: ModeT
  subRoutes?: Route[]
  isDisabled?: boolean
  // Иконка пункта: в свёрнутом сайдбаре видна только она
  icon?: IconType
  // Ещё адреса, на которых пункт подсвечен (вложенные страницы)
  matchUrls?: string[]
}

// Вариант сравнения для фильтра "Скрыть совпадающие с НСИ" (KRE-762):
// - "strict" — посимвольно: "ПБ 46 10-8" и "ПБ 46.10-8", "A500C" и "А500C" разные;
// - "normalized" — похожие латиница и кириллица одинаковы, разделители не важны.
// Как именно сравниваем — в util/validation/mappedNomenclature.ts
export type SameAsNsiMode = "strict" | "normalized"

export const configuration = {
  //* Проверка сметы: вариант сравнения для "Скрыть совпадающие с НСИ".
  // Поменять и задеплоить фронт — работает другой вариант
  smr: {
    sameAsNsiMode: "strict" as SameAsNsiMode,
  },
  sidebar: {
    routes: [
      //* Маппинг: УПД и сметы (Unistroy), история проверок
      {
        title: "Маппинг",
        subRoutes: [
          {
            title: "История сопоставлений",
            icon: FiClock,
            url: "mapping/result/iterations",
            mode: "CLASSIFIER",
            // Страницы проверки сметы и УПД — тоже "История"
            matchUrls: ["mapping/result"],
          },
          // Материалы и работы сейчас не используются: проверки сметчики
          // открывают по ссылкам из BI, это "История". Видны, но заблокированы
          {
            title: "Материалы",
            icon: FiBox,
            url: "mapping",
            mode: "CLASSIFIER",
            isDisabled: true,
          },
          {
            title: "Работы",
            icon: FiTool,
            mode: "CLASSIFIER",
            isDisabled: true,
          },
        ],
      },
      //* Ассистенты
      {
        title: "Ассистенты",
        subRoutes: [
          {
            title: "Базы Данных",
            icon: FiDatabase,
            url: "databases",
            mode: "DB",
          },
          {
            title: "Документы",
            icon: FiFileText,
            url: "documents",
            mode: "DOCS",
          },
        ],
      },
      //* QA бот для жителей
      {
        title: "QA бот для жителей",
        icon: FiMessageCircle,
        url: "orders_qa",
      },
      //* База знаний QA заявок
      {
        title: "База знаний QA заявок",
        icon: FiBookOpen,
        url: "qa-orders-knowledge-base",
      },
      //* Demo
      {
        title: "Демонстрация",
        icon: FiPlayCircle,
        url: "demo",
      },
    ] as Route[],
  },
}
